import DateFormatter from '@vivotek/lib-utility/formatDate';

export default DateFormatter;
